// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Doctor create form sections (Stitch) ——— */
.doctor-form {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.doctor-form__section {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 0;
  border: none;
  background: transparent;
}

.doctor-form__section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 8px;
  margin-bottom: 16px;
  border-bottom: 1px solid #E2E8F0;
  min-width: 0;
}

.doctor-form__section-head > div:first-child {
  min-width: 0;
  flex: 1 1 auto;
}

.doctor-form__section-title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  line-height: 1.3;
}

.doctor-form__section-subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748B;
  line-height: 1.4;
  text-transform: none;
  letter-spacing: normal;
  font-weight: 400;
}

.doctor-form__section-badge {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 500;
  color: #0EA5E9;
  background: #E0F2FE;
  border-radius: 999px;
  padding: 2px 10px;
  line-height: 1.4;
  white-space: nowrap;
}

.doctor-form__grid {
  display: grid;
  gap: 20px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.doctor-form__grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.doctor-form__grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.doctor-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
}

.doctor-form__field--span-2 {
  grid-column: span 2;
}

.doctor-form__field--full {
  grid-column: 1 / -1;
}

.doctor-form__label {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: #334155;
  line-height: 1.3;
}

.doctor-form__req {
  color: #F43F5E;
}

.doctor-form__optional {
  font-size: 12px;
  font-weight: 400;
  color: #94A3B8;
}

.doctor-form__help {
  margin: 0;
  font-size: 11px;
  color: #94A3B8;
  line-height: 1.4;
}

.doctor-form__fee-input {
  width: 100% !important;
}

.doctor-form .ant-form-item {
  margin-bottom: 0 !important;
  line-height: normal !important;
  font-size: 12px !important;
}

.doctor-form .ant-form-item-label {
  display: none;
  padding: 0 !important;
}

.doctor-form .ant-form-item-control-input {
  min-height: 36px !important;
}

.doctor-form .ant-form-item-explain-error {
  font-size: 12px;
  margin-top: 4px;
}

.doctor-form .ant-form-item-control,
.doctor-form .ant-form-item-control-input,
.doctor-form .ant-form-item-control-input-content {
  max-width: 100%;
  min-width: 0;
}

.doctor-form .ant-select,
.doctor-form .ant-picker,
.doctor-form .ant-input-number-group-wrapper,
.doctor-form .ant-input-affix-wrapper,
.doctor-form .doctor-form__fee-input {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}

.doctor-form .ant-input-affix-wrapper,
.doctor-form .ant-input-affix-wrapper-lg,
.doctor-form .ant-picker,
.doctor-form .ant-select-selector,
.doctor-form .ant-input-number {
  box-sizing: border-box !important;
  height: 36px !important;
  min-height: 36px !important;
  border-radius: 8px !important;
  border: 1px solid #CBD5E1 !important;
  font-size: 12px !important;
  color: #0F172A !important;
  box-shadow: none !important;
  background: #fff !important;
}

.doctor-form .ant-input-number {
  width: 100% !important;
  max-width: 100% !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 !important;
}

.doctor-form .ant-input-number .ant-input-number-input {
  height: 34px !important;
  padding: 0 12px !important;
  font-size: 12px !important;
}

.doctor-form .ant-input-number-group {
  width: 100%;
  max-width: 100%;
  display: flex;
}

.doctor-form .ant-input-number-group .ant-input-number {
  flex: 1 1 auto;
  min-width: 0;
}

.doctor-form .ant-input-number-group-addon {
  border-radius: 0 8px 8px 0 !important;
  border-color: #CBD5E1 !important;
  background: #F8FAFC !important;
  color: #64748B !important;
  font-size: 11px !important;
  font-weight: 500 !important;
}

.doctor-form .ant-input-affix-wrapper,
.doctor-form .ant-input-affix-wrapper-lg {
  padding: 0 12px !important;
  display: inline-flex !important;
  align-items: center !important;
  width: 100%;
}

.doctor-form .ant-form-item-control-input-content > input.ant-input:not(textarea) {
  box-sizing: border-box !important;
  height: 36px !important;
  min-height: 36px !important;
  margin: 0 !important;
  padding: 6px 12px !important;
  border-radius: 8px !important;
  border: 1px solid #CBD5E1 !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #0F172A !important;
  box-shadow: none !important;
  background: #fff !important;
}

.doctor-form .ant-input-affix-wrapper input.ant-input,
.doctor-form .ant-input-affix-wrapper-lg input.ant-input {
  box-sizing: border-box !important;
  height: 100% !important;
  min-height: 0 !important;
  max-height: none !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #0F172A !important;
}

.doctor-form .ant-picker {
  width: 100%;
  padding: 0 11px !important;
  display: flex !important;
  align-items: center !important;
}

.doctor-form .ant-picker-input {
  display: flex !important;
  align-items: center !important;
  width: 100%;
  height: 100%;
}

.doctor-form .ant-picker-input > input {
  font-size: 12px !important;
  line-height: 1.5 !important;
  height: auto !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.doctor-form input.ant-input::placeholder,
.doctor-form .ant-picker-input > input::placeholder,
.doctor-form .ant-input-number-input::placeholder {
  color: #94A3B8 !important;
  opacity: 1 !important;
}

.doctor-form .ant-select-selection-item,
.doctor-form .ant-select-selection-placeholder {
  line-height: 34px !important;
  display: flex !important;
  align-items: center !important;
  font-size: 12px !important;
}

.doctor-form .ant-select-single .ant-select-selector {
  display: flex !important;
  align-items: center;
  padding-inline: 11px !important;
}

.doctor-form .ant-form-item-feedback-icon {
  display: none !important;
}

.doctor-form .ant-input-password .ant-input-suffix {
  display: inline-flex !important;
  align-items: center !important;
  color: #94A3B8;
}

.doctor-form .ant-form-item-control-input-content > input.ant-input:not(textarea):hover,
.doctor-form .ant-input-affix-wrapper:hover,
.doctor-form .ant-picker:hover,
.doctor-form .ant-input-number:hover,
.doctor-form .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
  border-color: #94A3B8 !important;
}

.doctor-form .ant-form-item-control-input-content > input.ant-input:not(textarea):focus,
.doctor-form .ant-input-affix-wrapper-focused,
.doctor-form .ant-input-affix-wrapper:focus-within,
.doctor-form .ant-picker-focused,
.doctor-form .ant-input-number-focused,
.doctor-form .ant-select-focused .ant-select-selector {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;
}

.doctor-form .ant-input-affix-wrapper input.ant-input:focus {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

@media (max-width: 900px) {
  .doctor-form__grid--3,
  .doctor-form__grid--2 {
    grid-template-columns: 1fr;
  }

  .doctor-form__field--span-2 {
    grid-column: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/doctors/style.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,eAAe;EACf,YAAY;AACd;;AAEA;;;;;EAKE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;;;;EAKE,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,iCAAiC;EACjC,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;;;;EAKE,gCAAgC;AAClC;;AAEA;;;;;;EAME,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ——— Doctor create form sections (Stitch) ——— */\n.doctor-form {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.doctor-form__section {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n}\n\n.doctor-form__section-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 8px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #E2E8F0;\n  min-width: 0;\n}\n\n.doctor-form__section-head > div:first-child {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.doctor-form__section-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0F172A;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  line-height: 1.3;\n}\n\n.doctor-form__section-subtitle {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.4;\n  text-transform: none;\n  letter-spacing: normal;\n  font-weight: 400;\n}\n\n.doctor-form__section-badge {\n  flex-shrink: 0;\n  font-size: 11px;\n  font-weight: 500;\n  color: #0EA5E9;\n  background: #E0F2FE;\n  border-radius: 999px;\n  padding: 2px 10px;\n  line-height: 1.4;\n  white-space: nowrap;\n}\n\n.doctor-form__grid {\n  display: grid;\n  gap: 20px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.doctor-form__grid--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.doctor-form__grid--2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.doctor-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.doctor-form__field--span-2 {\n  grid-column: span 2;\n}\n\n.doctor-form__field--full {\n  grid-column: 1 / -1;\n}\n\n.doctor-form__label {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n  line-height: 1.3;\n}\n\n.doctor-form__req {\n  color: #F43F5E;\n}\n\n.doctor-form__optional {\n  font-size: 12px;\n  font-weight: 400;\n  color: #94A3B8;\n}\n\n.doctor-form__help {\n  margin: 0;\n  font-size: 11px;\n  color: #94A3B8;\n  line-height: 1.4;\n}\n\n.doctor-form__fee-input {\n  width: 100% !important;\n}\n\n.doctor-form .ant-form-item {\n  margin-bottom: 0 !important;\n  line-height: normal !important;\n  font-size: 12px !important;\n}\n\n.doctor-form .ant-form-item-label {\n  display: none;\n  padding: 0 !important;\n}\n\n.doctor-form .ant-form-item-control-input {\n  min-height: 36px !important;\n}\n\n.doctor-form .ant-form-item-explain-error {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.doctor-form .ant-form-item-control,\n.doctor-form .ant-form-item-control-input,\n.doctor-form .ant-form-item-control-input-content {\n  max-width: 100%;\n  min-width: 0;\n}\n\n.doctor-form .ant-select,\n.doctor-form .ant-picker,\n.doctor-form .ant-input-number-group-wrapper,\n.doctor-form .ant-input-affix-wrapper,\n.doctor-form .doctor-form__fee-input {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n}\n\n.doctor-form .ant-input-affix-wrapper,\n.doctor-form .ant-input-affix-wrapper-lg,\n.doctor-form .ant-picker,\n.doctor-form .ant-select-selector,\n.doctor-form .ant-input-number {\n  box-sizing: border-box !important;\n  height: 36px !important;\n  min-height: 36px !important;\n  border-radius: 8px !important;\n  border: 1px solid #CBD5E1 !important;\n  font-size: 12px !important;\n  color: #0F172A !important;\n  box-shadow: none !important;\n  background: #fff !important;\n}\n\n.doctor-form .ant-input-number {\n  width: 100% !important;\n  max-width: 100% !important;\n  display: flex !important;\n  align-items: center !important;\n  padding: 0 !important;\n}\n\n.doctor-form .ant-input-number .ant-input-number-input {\n  height: 34px !important;\n  padding: 0 12px !important;\n  font-size: 12px !important;\n}\n\n.doctor-form .ant-input-number-group {\n  width: 100%;\n  max-width: 100%;\n  display: flex;\n}\n\n.doctor-form .ant-input-number-group .ant-input-number {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.doctor-form .ant-input-number-group-addon {\n  border-radius: 0 8px 8px 0 !important;\n  border-color: #CBD5E1 !important;\n  background: #F8FAFC !important;\n  color: #64748B !important;\n  font-size: 11px !important;\n  font-weight: 500 !important;\n}\n\n.doctor-form .ant-input-affix-wrapper,\n.doctor-form .ant-input-affix-wrapper-lg {\n  padding: 0 12px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  width: 100%;\n}\n\n.doctor-form .ant-form-item-control-input-content > input.ant-input:not(textarea) {\n  box-sizing: border-box !important;\n  height: 36px !important;\n  min-height: 36px !important;\n  margin: 0 !important;\n  padding: 6px 12px !important;\n  border-radius: 8px !important;\n  border: 1px solid #CBD5E1 !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  line-height: 1.5 !important;\n  color: #0F172A !important;\n  box-shadow: none !important;\n  background: #fff !important;\n}\n\n.doctor-form .ant-input-affix-wrapper input.ant-input,\n.doctor-form .ant-input-affix-wrapper-lg input.ant-input {\n  box-sizing: border-box !important;\n  height: 100% !important;\n  min-height: 0 !important;\n  max-height: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  border: none !important;\n  border-radius: 0 !important;\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  line-height: 1.5 !important;\n  color: #0F172A !important;\n}\n\n.doctor-form .ant-picker {\n  width: 100%;\n  padding: 0 11px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.doctor-form .ant-picker-input {\n  display: flex !important;\n  align-items: center !important;\n  width: 100%;\n  height: 100%;\n}\n\n.doctor-form .ant-picker-input > input {\n  font-size: 12px !important;\n  line-height: 1.5 !important;\n  height: auto !important;\n  padding: 0 !important;\n  border: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.doctor-form input.ant-input::placeholder,\n.doctor-form .ant-picker-input > input::placeholder,\n.doctor-form .ant-input-number-input::placeholder {\n  color: #94A3B8 !important;\n  opacity: 1 !important;\n}\n\n.doctor-form .ant-select-selection-item,\n.doctor-form .ant-select-selection-placeholder {\n  line-height: 34px !important;\n  display: flex !important;\n  align-items: center !important;\n  font-size: 12px !important;\n}\n\n.doctor-form .ant-select-single .ant-select-selector {\n  display: flex !important;\n  align-items: center;\n  padding-inline: 11px !important;\n}\n\n.doctor-form .ant-form-item-feedback-icon {\n  display: none !important;\n}\n\n.doctor-form .ant-input-password .ant-input-suffix {\n  display: inline-flex !important;\n  align-items: center !important;\n  color: #94A3B8;\n}\n\n.doctor-form .ant-form-item-control-input-content > input.ant-input:not(textarea):hover,\n.doctor-form .ant-input-affix-wrapper:hover,\n.doctor-form .ant-picker:hover,\n.doctor-form .ant-input-number:hover,\n.doctor-form .ant-select:not(.ant-select-disabled):hover .ant-select-selector {\n  border-color: #94A3B8 !important;\n}\n\n.doctor-form .ant-form-item-control-input-content > input.ant-input:not(textarea):focus,\n.doctor-form .ant-input-affix-wrapper-focused,\n.doctor-form .ant-input-affix-wrapper:focus-within,\n.doctor-form .ant-picker-focused,\n.doctor-form .ant-input-number-focused,\n.doctor-form .ant-select-focused .ant-select-selector {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;\n}\n\n.doctor-form .ant-input-affix-wrapper input.ant-input:focus {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n@media (max-width: 900px) {\n  .doctor-form__grid--3,\n  .doctor-form__grid--2 {\n    grid-template-columns: 1fr;\n  }\n\n  .doctor-form__field--span-2 {\n    grid-column: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
